var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "files" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 0,
    class: "grid col-span-3 gap-6 container-images sm:grid-cols-2 md:grid-cols-5 sm:gap-y-8 lg:gap-x-8"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 1,
    class: "flex items-center justify-center pt-5 mt-5"
};
const _hoisted_6 = { class: "text-2xl text-gray-400" };
import { Link02Icon, SearchSmIcon, TextInputIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UITextSmMedium } from '@gohighlevel/ghl-ui';
import axios from 'axios';
import { computed, inject, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import TableView from '../components/TableView.vue';
import useContextMenu from '../composable/useContextMenu';
import useEmitter from '../composable/useEmitter';
import config from '../config';
import { useStore } from '../store';
import ContextMenu from './ContextMenu.vue';
import Accordion from './MediaAccordion.vue';
import UnsplashFile from './UnsplashFile.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UnsplashImages',
    props: {
        images: { default: () => [] },
        searchText: { default: '' },
        category: { default: 'unsplash' },
        accordionVisible: { type: Boolean, default: false },
        mediaLayout: {}
    },
    setup(__props) {
        const parentEmitter = inject('emitter');
        const emitter = useEmitter();
        const { t } = useI18n();
        const clickTimeout = ref(null);
        const contextMenuItems = [
            {
                name: t('common.getLink'),
                slug: 'link',
                icon() {
                    return renderIcon(Link02Icon);
                },
            },
            {
                name: t('common.addImageToMedia'),
                slug: 'addUnsplashImage',
                icon() {
                    return renderIcon(TextInputIcon);
                },
            },
        ];
        const { $state, updateActiveExternalObject, updatePreviewItem } = useStore();
        const activeItem = computed(() => $state.activeItem._id);
        function onSelectFile(image) {
            updateActiveExternalObject(image);
            emitter.emit('media-select-option', {
                file: image,
                fileType: 'external',
            });
        }
        function onClickImage(image) {
            var _a, _b;
            updatePreviewItem({
                url: (_b = (_a = image.urls) === null || _a === void 0 ? void 0 : _a.regular) !== null && _b !== void 0 ? _b : '',
                name: t('common.photoByUnsplash', [image.user.name, 'Unsplash']),
                user: image.user.name,
                published: image.updated_at,
                showImportButton: true,
            });
            if (clickTimeout.value) {
                clearTimeout(clickTimeout.value);
                clickTimeout.value = null;
            }
            clickTimeout.value = setTimeout(() => {
                emitter.emit('showPreview');
                clickTimeout.value = null;
            }, 300);
        }
        const { contextMenuItemClick } = useContextMenu();
        const unsplashMenuRef = ref();
        function handleFileClick(event, item) {
            unsplashMenuRef.value.showMenu(event, item);
        }
        function onclickFileSelect(image) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (clickTimeout.value) {
                        clearTimeout(clickTimeout.value);
                        clickTimeout.value = null;
                    }
                    const api = ((_a = image === null || image === void 0 ? void 0 : image.links) === null || _a === void 0 ? void 0 : _a.download_location) || '';
                    if (api) {
                        const endpoint = api + `&client_id=${config.UNSPLASH_CLIENT_IDS[0]}`;
                        const { data } = yield axios.get(endpoint);
                        const url = data.url ? data.url : image.urls ? image.urls.full : '';
                        parentEmitter.emit('media-center:attachment', { url });
                    }
                    else {
                        const url = image.urls ? image.urls.full : '';
                        parentEmitter.emit('media-center:attachment', { url });
                    }
                }
                catch (error) {
                    console.error('Error occurred while fetching image:', error);
                    // Handle the error here
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.searchText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(Accordion, {
                            showToggle: _ctx.accordionVisible,
                            open: true
                        }, {
                            title: _withCtx(() => [
                                (_ctx.mediaLayout === 'grid' || _ctx.category === 'all')
                                    ? (_openBlock(), _createBlock(_unref(UITextSmMedium), {
                                        key: 0,
                                        class: "text-gray-600"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Unsplash ")
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            content: _withCtx(() => [
                                (_ctx.mediaLayout === 'grid')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                                            return (_openBlock(), _createBlock(UnsplashFile, {
                                                key: image.id,
                                                id: image.id,
                                                onClick: ($event) => (onSelectFile(image)),
                                                activeItem: activeItem.value,
                                                image: image,
                                                class: "h-100 image-item",
                                                onDblclick: ($event) => (onclickFileSelect(image)),
                                                onContextmenu: _withModifiers(($event) => (handleFileClick($event, image)), ["prevent", "stop"]),
                                                onOnClickImage: ($event) => (onClickImage(image))
                                            }, null, 8 /* PROPS */, ["id", "onClick", "activeItem", "image", "onDblclick", "onContextmenu", "onOnClickImage"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(TableView, {
                                            id: "identifier.BlogList_Table",
                                            files: _ctx.images,
                                            type: "unsplash"
                                        }, null, 8 /* PROPS */, ["files"])
                                    ]))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["showToggle"])
                    ]))
                    : (!_ctx.searchText && _ctx.category == 'unsplash')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_unref(SearchSmIcon), { class: "mr-2 text-gray-400 h-7 w-7" }),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('common.searchSomething')), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true),
                _createVNode(ContextMenu, {
                    elementId: 'unsplashMenu',
                    options: contextMenuItems,
                    ref_key: "unsplashMenuRef",
                    ref: unsplashMenuRef,
                    onOptionClicked: _unref(contextMenuItemClick)
                }, null, 8 /* PROPS */, ["onOptionClicked"])
            ]));
        };
    }
});
